<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dDOQJm/tc-custom/9781609450250.jpg?1726871162754" alt="This image is the cover for the book Goodbye Kiss"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Goodbye Kiss
      </h1>
      <p class="bookDescription body article font2">
        <b>“There isn’t a scintilla of innocence in this masterpiece of Italian noir . . . [Carlotto’s] version of hardboiled crime is criminal all the way.” —<i>The Globe and Mail</i></b><br/><br/>Giorgio Pellegrini is wanted in Italy for a series of crimes linked to political extremism. He has been hiding out in Central America, half-heartedly lending a hand to a group of leftwing militants engaged in a bloody civil war. After the Comandante orders the assassination of his companion and compatriot, Pellegrini decides it might just be time to head back home. As devoid of morals now as he once was full of idealistic fervor, an inveterate womanizer and a seasoned opportunist, Giorgio seems willing to do almost anything to avoid prison, from selling out his old pals in The Movement to cutting deals with crooked cops. But just how far is he willing to go to earn himself the guise of respectability in a society that appears to have lost the values it once defended so fiercely?<br/><br/>Master of Mediterranean noir, hardboiled crime novels in which seductive cities like Marseilles and Naples become principle protagonists, Massimo Carlotto is arguably “the best living Italian crime writer” (<i>Il Manifesto</i>). At once a harsh criticism of Italy’s social malaise and a scathing indictment of its political elite, <i>The Goodbye Kiss</i> tells the gripping story of a solitary man with nothing left to lose and nothing to win. Carlotto’s spare narrative style and his commitment to the unvarnished truth have already won him a vast and loyal readership. With Giorgio Pellegrini, he has created one of the most compelling characters in modern Italian literature and furnished readers with an unsettling portrait of contemporary criminality.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Massimo Carlotto
      </h2>
      
      <p class="authorDescription body article"><P><B>Massimo Carlotto</B> was born in Padua, Italy. In addition to the many titles in his extremely popular “Alligator” series, he is also the author of <I>The Fugitive</I>, <I>Death’s Dark Abyss</I>, <I>Poisonville</I>, <I>Bandit Love</I>, and <I>At the End of a Dull Day</I>. He is one of Italy’s most popular authors and a major exponent of the Mediterranean Noir novel.</P><br/><br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0adfcee9